module.exports = __webpack_public_path__ + "img/Check-out-icon.3e78668d.svg";